export default __webpack_public_path__ + "static/media/fire.1edd2da7.png";